<template>
    <div class="quiz-popup" :style="overlayBgStyle">
        <div class="close-button">
            <q-btn icon="close" flat round dense @click="$emit('closeQuiz')" />
            <ReturnHomeButton @click="$emit('closeAllDialogs')" />
        </div>
        <QuizPlayer :quizId="quizId" />
    </div>
</template>

<script>
import ReturnHomeButton from './ReturnHomeButton.vue';
import QuizPlayer from './QuizPlayer.vue';
import { useOverlayBg } from '../composables/useOverlayBg';

export default {
    name: 'QuizOverlay',
    components: { ReturnHomeButton, QuizPlayer },
    props: { quizId: { required: true } },
    setup() {
        const { overlayBgStyle } = useOverlayBg();
        return { overlayBgStyle };
    },
};
</script>

<style scoped>
.quiz-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(217, 217, 217, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    gap: 10px;
    z-index: 10001;
}
</style>
